import React, {createRef, useContext} from "react";
import {useHistory} from "react-router-dom";
import {useAuth0} from "@auth0/auth0-react";
import {useQueryClient} from "react-query";
import {makeStyles} from "@material-ui/core/styles";
import moment from "moment";

import "../../App.css";
import PageHeader from "../../blocks/PageHeader.js";
import PageFooter from "../../blocks/PageFooter";
import BookingQueueStyles from "./styles/BookingQueueStyles";
import BookingForm from "./components/BookingForm";
import useCurrencies from "../../services/currencies/useCurrencies";
import useExchangeRates from "../../services/currencies/useExchangeRatesWithName";
import {useSettings} from "../../services/settings";
import InternalSlrForm from "./components/InternalSlrForm";
import SystemContext from "../../SystemContext";


const AccessControl = require ("../../AccessControl");

function InternalSpecialLoadRequest(props) {
  const SystemData = useContext(SystemContext);
  const classes = makeStyles(BookingQueueStyles)();

  const { isAuthenticated, user } = useAuth0();
  const canEdit = AccessControl.userHasAccess(user, ["Super Admin", "Manage BOOKINGS", "Manage SLR"]);


  const tableRef = createRef({state: {lastEditingRow: false}});
  const queryClient = useQueryClient();
  const extraKeys = ["SYSTEM", moment().format("YYYY-MM-DD")];
  const currencies = useCurrencies(tableRef, queryClient, []);
  const exchangeRates = useExchangeRates({tableRef, queryClient, extraKeys});
  const terms = useSettings({tableRef, queryClient, extraKeys: ["TERMS"]});

  const history = useHistory();
  const handleClose = event => {
    SystemData.goHome(history);
  };

  const record = {
    bookingType: "SPECIAL LOAD",
    bookingStatus: "PRE-ADVICE",
    commodity: "SL",
    specialLoad: "",
    stackable: "NONE",
    tiltable: "NONE",
    crated: "NONE",
    dgr: "NONE",
    avi: "NONE",
    outSized: "NONE",
    delivery: "",
    dimensions: [],
    rates: [],
    documents: [],
  }

  return (isAuthenticated &&
    <div
      className="BookingQueue"
      style={{
        backgroundColor: "#eeeeee",
        color: "#1b4481",
        fontWeight: 400,
        fontFamily: "Ubuntu,sans-serif",
        minHeight: "100vh",
      }}
    >
      <PageHeader
        parentProps={props}
        activeMenuItem="specialloadrequest"
        pageName="Special Load Request"
        loggedInUser={user}
        logout={""}
      ></PageHeader>
      <div
        style={{
          marginLeft: 40,
          marginRight: 40,
          height: 2,
          backgroundColor: "#b7c3d4",
        }}
      ></div>
      <div style={{ height: 10 }}></div>

      <div
        className={classes.rooted}
        style={{ marginLeft: 40, marginRight: 40, minHeight: `calc(100vh - ${(99+2+10+57+4)}px)`, backgroundColor: "#ffffff"}}
      >
        <div style={{display: "flex"}}>
          <InternalSlrForm
            record={record}
            canEdit={canEdit}
            newBooking={true}
            spotBooking={false}
            formMode={"SLR"} // GSA - for GSA bookings (does not require GSA selection), OPERATOR - for system operator bookings (requires GSA selection), SLR - for special load requests
            captureParticipants={false}
            close={handleClose}
            classes={classes}
            exchangeRates={exchangeRates.data}
            currencies={currencies.data}
            terms={terms.data}
            dialogStates={{showDialog: true}}
            showFullPage={false}
          />
        </div>
      </div>

      <PageFooter></PageFooter>
    </div>
  );
}

export default InternalSpecialLoadRequest;
